var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V7.875H1.79959M22.9149 10.625C22.2383 5.19882 17.6095 1 12 1C7.38361 1 3.4314 3.84373 1.79959 7.875M1.79959 7.875H7.875M23 23V16.125H22.2004M22.2004 16.125C20.5686 20.1563 16.6164 23 12 23C6.39053 23 1.76174 18.8012 1.0851 13.375M22.2004 16.125H16.125",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgSync;